import type { DetailedReviewType } from "@asap/shared/types/contract-comment";
import type { ContractCommentType } from "@asap/shared/types/supabase.types.gen";
import type { ContractStatus } from "@asap/shared/utils/supabase.enum";

type ContractReviewTypeInput = {
  status: ContractStatus;
  isAmendment: boolean;
  lastCommentType: ContractCommentType | null;
};

/** The review screen to show for a contract, by its status and, when the owner modifies it, by who asked. */
export const getContractReviewType = ({
  status,
  isAmendment,
  lastCommentType,
}: ContractReviewTypeInput): DetailedReviewType | null => {
  switch (status) {
    case "to_validate":
      return "manager_to_owner";
    case "to_process":
      return "admin_to_owner";
    case "to_send":
    case "waiting_for_signature":
      return "owner_to_admin";
    case "to_modify_by_owner":
      return !isAmendment && lastCommentType === "manager_to_owner"
        ? "to_modify_by_owner_from_manager"
        : "to_modify_by_owner_from_admin";
    case "to_modify_by_admin":
      return "to_modify_by_admin";
    default:
      return null;
  }
};
